module.exports = __webpack_public_path__ + "img/case12-中国铁建.0dc75534.png";